export const categories = [
  { id: 1, name: '全部', slug: 'all', icon: 'ri-global-line' },
  { id: 2, name: '恋爱', slug: 'romance', icon: 'ri-heart-line' },
  { id: 3, name: '奇幻', slug: 'fantasy', icon: 'ri-magic-line' },
  { id: 4, name: '动作', slug: 'action', icon: 'ri-flashlight-line' },
  { id: 5, name: '悬疑', slug: 'thriller', icon: 'ri-search-eye-line' },
  { id: 6, name: '搞笑', slug: 'comedy', icon: 'ri-emotion-laugh-line' },
  { id: 7, name: '都市', slug: 'urban', icon: 'ri-building-line' },
  { id: 8, name: 'BL', slug: 'bl', icon: 'ri-user-heart-line' },
  { id: 9, name: '古风', slug: 'historical', icon: 'ri-empathize-line' },
  { id: 10, name: '校园', slug: 'school', icon: 'ri-book-open-line' },
];

export const comics = [
  {
    id: 1,
    title: '社内相亲',
    slug: 'sanei-xiangqin',
    author: '作者：Haehwa / Narak',
    cover: 'https://readdy.ai/api/search-image?query=korean%20manhwa%20romance%20office%20couple%20elegant%20illustration%20style%2C%20soft%20warm%20lighting%2C%20clean%20white%20background%2C%20two%20characters%20close%20together%2C%20professional%20art%2C%20webtoon%20style&width=400&height=560&seq=comic-01&orientation=portrait',
    category: 'romance',
    rating: 9.6,
    status: '连载中',
    description: '平凡的上班族申夏莉代替闺蜜去相亲，本想搞砸相亲的她却意外发现对方竟是自己的老板姜泰武！一场充满欢笑与心动的办公室恋爱故事就此展开。',
    chapters: 128,
    updateTime: '2026-08-05',
    views: 1523000,
    featured: true,
    hot: true,
  },
  {
    id: 2,
    title: '我独自升级',
    slug: 'wo-duzi-shengji',
    author: '作者：Chugong / DUBU',
    cover: 'https://readdy.ai/api/search-image?query=korean%20manhwa%20action%20fantasy%20warrior%20with%20dark%20shadow%20powers%2C%20dramatic%20lighting%2C%20intense%20atmosphere%2C%20clean%20composition%2C%20webtoon%20art%20style&width=400&height=560&seq=comic-02&orientation=portrait',
    category: 'action',
    rating: 9.8,
    status: '已完结',
    description: '被称为「人类最弱兵器」的E级猎人成振宇，在一次双重地下城事故中濒临死亡，却意外获得了「系统」的力量。从此，他可以无限升级变强，一步步揭开隐藏在猎人世界背后的惊天秘密。',
    chapters: 179,
    updateTime: '2026-07-20',
    views: 3250000,
    featured: true,
    hot: true,
  },
  {
    id: 3,
    title: '某天成为公主',
    slug: 'moutian-chengwei-gongzhu',
    author: '作者：Plutus / Spoon',
    cover: 'https://readdy.ai/api/search-image?query=korean%20manhwa%20fantasy%20beautiful%20princess%20with%20long%20golden%20hair%20in%20elegant%20dress%2C%20royal%20palace%20background%2C%20soft%20dreamy%20colors%2C%20webtoon%20style&width=400&height=560&seq=comic-03&orientation=portrait',
    category: 'fantasy',
    rating: 9.5,
    status: '连载中',
    description: '一觉醒来竟变成了小说里被父皇杀死的悲催公主？！为了活下去，被抛弃的公主阿西娅开始拼命讨好冷酷的父皇。一场萌系公主的宫廷生存记，甜中带虐。',
    chapters: 155,
    updateTime: '2026-08-04',
    views: 2180000,
    featured: true,
    hot: true,
  },
  {
    id: 4,
    title: '女神降临',
    slug: 'nvshen-jianglin',
    author: '作者：Yaongyi',
    cover: 'https://readdy.ai/api/search-image?query=korean%20manhwa%20beauty%20makeup%20transformation%20school%20girl%2C%20stylish%20fashion%2C%20bright%20campus%20background%2C%20vibrant%20colors%2C%20webtoon%20romance%20style&width=400&height=560&seq=comic-04&orientation=portrait',
    category: 'school',
    rating: 9.3,
    status: '已完结',
    description: '因相貌被霸凌的她通过化妆术脱胎换骨，成为校园女神。但素颜的秘密能否守住？两位校草的出现让她的校园生活充满未知与心动。',
    chapters: 223,
    updateTime: '2026-06-15',
    views: 4100000,
    featured: false,
    hot: true,
  },
  {
    id: 5,
    title: '全知读者视角',
    slug: 'quanzhi-duzhe-shijiao',
    author: '作者：sing N song / Sleepy-C',
    cover: 'https://readdy.ai/api/search-image?query=korean%20manhwa%20apocalyptic%20fantasy%20male%20protagonist%20in%20dark%20coat%2C%20dramatic%20pose%2C%20mysterious%20atmosphere%2C%20webtoon%20action%20style&width=400&height=560&seq=comic-05&orientation=portrait',
    category: 'fantasy',
    rating: 9.9,
    status: '连载中',
    description: '金独子是一个普通上班族，唯一的爱好就是看网络小说。某天他追了十年的小说完结了，而小说中的末日竟在现实中降临。作为唯一的「全知读者」，他能否改变这个世界的命运？',
    chapters: 210,
    updateTime: '2026-08-05',
    views: 5600000,
    featured: true,
    hot: true,
  },
  {
    id: 6,
    title: '观相师',
    slug: 'guanxiangshi',
    author: '作者：Han Dong-Woo',
    cover: 'https://readdy.ai/api/search-image?query=korean%20manhwa%20mystery%20detective%20story%20man%20in%20trench%20coat%2C%20rainy%20night%20atmosphere%2C%20noir%20style%2C%20dramatic%20shadows%2C%20webtoon%20art&width=400&height=560&seq=comic-06&orientation=portrait',
    category: 'thriller',
    rating: 9.2,
    status: '连载中',
    description: '拥有看透人心的特殊能力，他却选择成为一名普通的「观相师」。在帮人看相的过程中，一桩桩离奇案件将他卷入无法想象的黑暗深渊。',
    chapters: 87,
    updateTime: '2026-08-03',
    views: 980000,
    featured: false,
    hot: false,
  },
  {
    id: 7,
    title: '搞笑一家人',
    slug: 'gaoxiao-yijiaren',
    author: '作者：Jo Seok',
    cover: 'https://readdy.ai/api/search-image?query=korean%20manhwa%20funny%20family%20comedy%2C%20chaotic%20household%20scene%2C%20bright%20colorful%20style%2C%20cartoonish%20expressions%2C%20webtoon%20comedy&width=400&height=560&seq=comic-07&orientation=portrait',
    category: 'comedy',
    rating: 9.1,
    status: '已完结',
    description: '一个平凡家庭中每天上演的爆笑日常。严厉的爸爸、唠叨的妈妈、调皮的孩子们，让你在捧腹大笑中感受家的温暖。',
    chapters: 310,
    updateTime: '2026-03-10',
    views: 2900000,
    featured: false,
    hot: false,
  },
  {
    id: 8,
    title: '她的私生活',
    slug: 'tade-sishenghuo',
    author: '作者：Kim Sung-Yeon',
    cover: 'https://readdy.ai/api/search-image?query=korean%20manhwa%20romance%20stylish%20woman%20in%20art%20gallery%2C%20elegant%20modern%20setting%2C%20warm%20lighting%2C%20sophisticated%20webtoon%20style&width=400&height=560&seq=comic-08&orientation=portrait',
    category: 'romance',
    rating: 9.4,
    status: '连载中',
    description: '美术馆策展人成德美隐藏着一个秘密——她是偶像团体的狂热站姐。当新馆长莱恩发现了她的秘密，两人之间展开了一段充满反差魅力的浪漫故事。',
    chapters: 98,
    updateTime: '2026-08-04',
    views: 1350000,
    featured: false,
    hot: true,
  },
  {
    id: 9,
    title: '深渊传说',
    slug: 'shenyuan-chuanshuo',
    author: '作者：Lee Jong-Hyuk',
    cover: 'https://readdy.ai/api/search-image?query=korean%20manhwa%20dark%20fantasy%20adventure%2C%20epic%20warrior%20with%20sword%2C%20ancient%20ruins%20background%2C%20mysterious%20blue%20glow%2C%20atmospheric%20webtoon%20style&width=400&height=560&seq=comic-09&orientation=portrait',
    category: 'fantasy',
    rating: 9.0,
    status: '连载中',
    description: '深渊之下，埋藏着上古的秘密。少年亚伦无意中唤醒了沉睡千年的力量，踏上了一场改变命运的深渊之旅。',
    chapters: 65,
    updateTime: '2026-08-02',
    views: 720000,
    featured: false,
    hot: false,
  },
  {
    id: 10,
    title: '霸道总裁的契约妻',
    slug: 'badao-zongcai-qiyueqi',
    author: '作者：Park Soo-Jung',
    cover: 'https://readdy.ai/api/search-image?query=korean%20manhwa%20romance%20ceo%20and%20contract%20marriage%2C%20luxury%20penthouse%20setting%2C%20elegant%20couple%2C%20soft%20romantic%20lighting%2C%20webtoon%20style&width=400&height=560&seq=comic-10&orientation=portrait',
    category: 'urban',
    rating: 9.3,
    status: '连载中',
    description: '为了偿还父亲的债务，她签下了一纸契约婚姻。本以为只是一场交易，却不知霸道总裁早已对她暗生情愫。契约的尽头，是自由还是真爱？',
    chapters: 142,
    updateTime: '2026-08-05',
    views: 1850000,
    featured: false,
    hot: true,
  },
  {
    id: 11,
    title: '剑尊归来',
    slug: 'jianzun-guilai',
    author: '作者：Yu Hyun',
    cover: 'https://readdy.ai/api/search-image?query=korean%20manhwa%20martial%20arts%20warrior%20with%20long%20sword%2C%20ancient%20oriental%20setting%2C%20dynamic%20action%20pose%2C%20dramatic%20ink%20wash%20style%2C%20webtoon&width=400&height=560&seq=comic-11&orientation=portrait',
    category: 'action',
    rating: 9.7,
    status: '连载中',
    description: '天下第一剑客死后百年重生，却发现江湖已面目全非。昔日辉煌的剑道沦为末流，他要让剑道的荣光重新照耀天下！',
    chapters: 112,
    updateTime: '2026-08-05',
    views: 2400000,
    featured: false,
    hot: true,
  },
  {
    id: 12,
    title: '校园怪谈',
    slug: 'xiaoyuan-guaitan',
    author: '作者：Kim Min-Ji',
    cover: 'https://readdy.ai/api/search-image?query=korean%20manhwa%20horror%20school%20mystery%2C%20dark%20corridor%20with%20ghostly%20figure%2C%20eerie%20atmosphere%2C%20suspense%20webtoon%20style%2C%20cold%20tones&width=400&height=560&seq=comic-12&orientation=portrait',
    category: 'thriller',
    rating: 8.9,
    status: '连载中',
    description: '新学期的钟声敲响，但这座校园里流传着七大怪谈。当怪谈一个接一个变成现实，学生们才发现——有些传说，根本不是传说。',
    chapters: 56,
    updateTime: '2026-08-01',
    views: 650000,
    featured: false,
    hot: false,
  },
];

export const latestUpdates = [
  { id: 1, comicTitle: '全知读者视角', chapterTitle: '第210话 结局的序幕', updateTime: '2026-08-05 14:23', comicSlug: 'quanzhi-duzhe-shijiao', chapterId: 210 },
  { id: 2, comicTitle: '社内相亲', chapterTitle: '第128话 最后的告白', updateTime: '2026-08-05 12:10', comicSlug: 'sanei-xiangqin', chapterId: 128 },
  { id: 3, comicTitle: '剑尊归来', chapterTitle: '第112话 血战到底', updateTime: '2026-08-05 10:45', comicSlug: 'jianzun-guilai', chapterId: 112 },
  { id: 4, comicTitle: '霸道总裁的契约妻', chapterTitle: '第142话 温柔的陷阱', updateTime: '2026-08-05 09:30', comicSlug: 'badao-zongcai-qiyueqi', chapterId: 142 },
  { id: 5, comicTitle: '某天成为公主', chapterTitle: '第155话 父皇的心意', updateTime: '2026-08-04 20:15', comicSlug: 'moutian-chengwei-gongzhu', chapterId: 155 },
  { id: 6, comicTitle: '她的私生活', chapterTitle: '第98话 秘密花园', updateTime: '2026-08-04 18:00', comicSlug: 'tade-sishenghuo', chapterId: 98 },
  { id: 7, comicTitle: '观相师', chapterTitle: '第87话 最后的谜底', updateTime: '2026-08-03 22:30', comicSlug: 'guanxiangshi', chapterId: 87 },
  { id: 8, comicTitle: '深渊传说', chapterTitle: '第65话 古神的低语', updateTime: '2026-08-02 16:45', comicSlug: 'shenyuan-chuanshuo', chapterId: 65 },
  { id: 9, comicTitle: '校园怪谈', chapterTitle: '第56话 消失的教室', updateTime: '2026-08-01 11:20', comicSlug: 'xiaoyuan-guaitan', chapterId: 56 },
  { id: 10, comicTitle: '我独自升级', chapterTitle: '第179话 终章 · 觉醒', updateTime: '2026-07-20 08:00', comicSlug: 'wo-duzi-shengji', chapterId: 179 },
];

export const banners = [
  {
    id: 1,
    comicSlug: 'quanzhi-duzhe-shijiao',
    title: '全知读者视角',
    subtitle: '现象级韩国漫画 · 全网评分9.9',
    description: '当小说变成现实，唯一的读者能否改变世界的命运？',
    bgImage: 'https://readdy.ai/api/search-image?query=korean%20manhwa%20epic%20fantasy%20banner%20background%2C%20dramatic%20scene%20with%20warriors%20and%20monsters%2C%20cinematic%20lighting%2C%20dark%20atmosphere%2C%20warm%20golden%20accents%2C%20webtoon%20art%20style&width=1600&height=700&seq=banner-01&orientation=landscape',
    badge: '🔥 全网热门',
  },
  {
    id: 2,
    comicSlug: 'wo-duzi-shengji',
    title: '我独自升级',
    subtitle: '完结神作 · 3.2亿次阅读',
    description: '从E级猎人到最强王者，一段热血沸腾的升级之路',
    bgImage: 'https://readdy.ai/api/search-image?query=korean%20manhwa%20action%20epic%20battle%20scene%2C%20powerful%20warrior%20with%20glowing%20blue%20energy%2C%20dramatic%20cinematic%20composition%2C%20intense%20atmosphere%2C%20webtoon%20style&width=1600&height=700&seq=banner-02&orientation=landscape',
    badge: '⭐ 完结神作',
  },
  {
    id: 3,
    comicSlug: 'moutian-chengwei-gongzhu',
    title: '某天成为公主',
    subtitle: '甜宠宫廷 · 2.1亿次阅读',
    description: '穿越成短命公主？不存在的！萌系公主的逆袭生存记',
    bgImage: 'https://readdy.ai/api/search-image?query=korean%20manhwa%20fantasy%20royal%20palace%20scene%2C%20beautiful%20princess%20in%20elegant%20garden%2C%20soft%20warm%20sunlight%2C%20dreamy%20romantic%20atmosphere%2C%20webtoon%20style&width=1600&height=700&seq=banner-03&orientation=landscape',
    badge: '💎 热门推荐',
  },
];